import { create } from 'zustand';
import { fetchProductsFromSheet } from '../api/fetchProductsFromSheet';

export const useProductsStore = create((set, get) => ({
  products: [],
  loading: false,
  error: null,
  cart: {},

  fetch: async () => {
    set({ loading: true, error: null });
    try {
      const data = await fetchProductsFromSheet();
      set({ products: data, loading: false });
    } catch (e) {
      set({ error: 'Ошибка при загрузке данных', loading: false });
    }
  },

  getProductById: (name) => {
    const state = get();
    return state.products.find((p) => p['Товар'] === name);
  },
  addToCart: (product) => {
    const state = get();
    const cart = { ...state.cart };
    if (cart[product['Товар']]) {
      cart[product['Товар']].quantity += 1;
    } else {
      cart[product['Товар']] = { product, quantity: 1 };
    }
    set({ cart });
  },

  removeFromCart: (product) => {
    const state = get();
    const cart = { ...state.cart };
    if (cart[product['Товар']]) {
      cart[product['Товар']].quantity -= 1;
      if (cart[product['Товар']].quantity < 1) {
        delete cart[product['Товар']];
      }
    }
    set({ cart });
  },

  clearCart: () => {
    set({ cart: {} });
  },

  getCartTotal: () => {
    const state = get();
    return Object.values(state.cart).reduce(
      (sum, item) => sum + Number(item.product['Цена'] || 0) * item.quantity,
      0
    );
  },
}));
